import { render, staticRenderFns } from "./ReferralsRateReferred.vue?vue&type=template&id=68061eb6&scoped=true"
import script from "./ReferralsRateReferred.vue?vue&type=script&lang=js"
export * from "./ReferralsRateReferred.vue?vue&type=script&lang=js"
import style0 from "./ReferralsRateReferred.vue?vue&type=style&index=0&id=68061eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68061eb6",
  null
  
)

export default component.exports